/* override functions api.jquery.js */
var luxsterOpenMiniCartAfterAdd = false;
var luxsterCartJQuery = window.jQuery;
var luxsterLastCartItemCount = Number(luxsterCartJQuery('.bigcounter').first().text()) || 0;

function openMiniCart() {
  var $trigger = luxsterCartJQuery('.cart_trigger[data-toggle="dropdown"]').first();
  if (!$trigger.length || $trigger.closest('.dropdown').hasClass('show') || typeof $trigger.dropdown !== 'function') return;
  $trigger.dropdown('toggle');
}

Shopify.onItemAdded = function(line_item, openAfterUpdate) {
  luxsterOpenMiniCartAfterAdd = openAfterUpdate !== false;
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.cart_list');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
   	var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('.error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
  setTimeout(function () {
  	jQuery('.shopping__cart').removeClass("shopping__cart__on");
    jQuery('.body__overlay').removeClass("is-visible");
  },2000);
}

Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, variant_id,callback) {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      beforeSend: function(){
        if(form_id == "add-item-qv") {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
        }
      },
      data: jQuery('#' + form_id).serialize(),
      dataType: 'json',
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else {
          if(form_id != "add-item-qv") {
            Shopify.cartPopapForm(variant_id);
          } else {
          	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
            jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
            setTimeout(function(){
              	jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
            	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
            }, 2000);
          }
          Shopify.onItemAdded(line_item);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        if(form_id != "add-item-qv") {
          Shopify.onError(XMLHttpRequest, textStatus);
        } else {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
          jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
          setTimeout(function(){
            jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_item, false);
      }
    };
    jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function(variant_id) {
  	var image = jQuery('.'+variant_id+':first .popup_cart_image').attr("src");
  	var title = jQuery('.'+variant_id+':first .popup_cart_title').text();
  	jQuery('.popupimage').attr("src",''+image+'');
  	jQuery('.productmsg').text(''+title+'');  
  	jQuery('#modalAddToCart').modal("toggle");
}
Shopify.cartPopapForm = function(variant_id) {
  	var image = jQuery('.product_variant_image').attr("src");
  	var title = jQuery('#popup_cart_title').text();
  	jQuery('.popupimage').attr("src",''+image+'');
	jQuery('.productmsg').text(''+title+'');
	jQuery('#modalAddToCart').modal("toggle");
}

function miniCartEscapeHtml(value) {
  return String(value || '').replace(/[&<>'"]/g, function(character) {
    return {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;'
    }[character];
  });
}

function miniCartImageUrl(item) {
  var image = item.image || (item.featured_image && item.featured_image.url) || '';
  if (!image) return '';
  return image + (image.indexOf('?') === -1 ? '?' : '&') + 'width=240';
}

function miniCartItemMarkup(item, formatMoney) {
  var productTitle = miniCartEscapeHtml(item.product_title || item.title);
  var finalPrice = typeof item.final_price === 'number' ? item.final_price : item.price;
  var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
    ? '<span class="mini-cart-variant">' + miniCartEscapeHtml(item.variant_title) + '</span>'
    : '';
  var imageUrl = miniCartEscapeHtml(miniCartImageUrl(item));
  var itemUrl = miniCartEscapeHtml(item.url);

  return '<li class="mini-cart-item">'
    + '<a href="javascript:void(0);" class="item_remove" onclick="Shopify.removeItem(' + item.variant_id + ')"><i class="ion-close"></i></a>'
    + '<a href="' + itemUrl + '" class="mini-cart-product">'
    + '<img class="mini-cart-image" src="' + imageUrl + '" alt="' + productTitle + '">'
    + '<span class="mini-cart-title">' + productTitle + '</span></a>'
    + variantTitle
    + '<span class="cart_quantity mini-cart-quantity">' + item.quantity + ' × <span class="cart_amount"><span class="price_symbole">'
    + Shopify.formatMoney(finalPrice, formatMoney) + '</span></span></span></li>';
}

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = "<span class='money'>${{amount}}</span>";
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
			
          if (value.length) {
            jQuery(".cart_box").css({"display": "block"});
            jQuery(".cart-empty-title").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              jQuery(miniCartItemMarkup(item, formatMoney)).appendTo(table);
            });
          }
          else {
            jQuery(".cart_box").css({"display": "none"});
			jQuery(".cart-empty-title").css({"display": "block"});
          }
        }
      });
    }
  }

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".bigcounter", cart.item_count);

  jQuery('.currency .active').trigger('click');

  var shouldOpenMiniCart = luxsterOpenMiniCartAfterAdd || Number(cart.item_count) > luxsterLastCartItemCount;
  luxsterOpenMiniCartAfterAdd = false;
  luxsterLastCartItemCount = Number(cart.item_count) || 0;
  if (shouldOpenMiniCart) openMiniCart();
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};
